"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _HeatmapCellTooltip = _interopRequireDefault(require("./HeatmapCellTooltip.js"));

var _he = _interopRequireDefault(require("he"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var reactToHtml = function reactToHtml(component) {
  return _he["default"].decode(_server["default"].renderToStaticMarkup(component));
};

var _default = function _default(config) {
  return function (series, point) {
    var o = {
      colour: point.color,
      xLabel: point.options.info.xLabel || series.xAxis.categories[point.x].label,
      xProperties: series.xAxis.categories[point.x].info.tooltip.properties,
      yLabel: series.yAxis.categories[point.y].label,
      value: point.value,
      replicates: series.xAxis.categories[point.x].info.tooltip.replicates || undefined
    };
    Object.keys(point.options.info).forEach(function (key) {
      return o[key] = point.options.info[key];
    });
    return reactToHtml( /*#__PURE__*/_react["default"].createElement(_HeatmapCellTooltip["default"], _extends({}, o, {
      config: config
    })));
  };
};

exports["default"] = _default;